// extracted by mini-css-extract-plugin
export default {"heading":"IconHeading_heading__MvzXK","icon":"IconHeading_icon__J4OCz","title":"IconHeading_title__1OpCE"};